import React from "react";
import { Box } from "@mui/material";

const BrandThinkingLoader = ({ fullScreen = false, minHeight, size = 76 }) => (
  <Box
    role="status"
    aria-label="CrediArc is loading"
    sx={{
      width: "100%",
      minHeight: minHeight || (fullScreen ? "100vh" : 320),
      display: "grid",
      placeItems: "center",
      background: fullScreen ? "#F7F9FC" : "transparent",
    }}
  >
    <Box
      sx={{
        position: "relative",
        width: size + 28,
        height: size + 28,
        display: "grid",
        placeItems: "center",
        "@keyframes crediarc-think-pulse": {
          "0%, 100%": { transform: "scale(.82)", opacity: 0 },
          "35%": { opacity: 0.28 },
          "75%": { transform: "scale(1.12)", opacity: 0 },
        },
        "@keyframes crediarc-think-float": {
          "0%, 100%": { transform: "translate3d(0, 2px, 0) scale(.82)", opacity: 0.42 },
          "45%": { transform: "translate3d(3px, -4px, 0) scale(1)", opacity: 1 },
        },
        "@media (prefers-reduced-motion: reduce)": {
          "& *, &::before": { animation: "none !important" },
        },
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: "absolute",
          inset: 4,
          borderRadius: "50%",
          border: "2px solid rgba(126, 197, 83, .55)",
          animation: "crediarc-think-pulse 1.8s ease-out infinite",
        }}
      />
      <Box
        component="img"
        src="/favicon.png"
        alt=""
        aria-hidden="true"
        sx={{ width: size, height: size, display: "block", filter: "drop-shadow(0 8px 18px rgba(31, 51, 92, .14))" }}
      />
      {[
        { width: 10, top: 5, right: 17, delay: "0s" },
        { width: 7, top: 18, right: 4, delay: ".18s" },
        { width: 5, top: 34, right: 0, delay: ".36s" },
      ].map((dot, index) => (
        <Box
          key={index}
          aria-hidden="true"
          sx={{
            position: "absolute",
            width: dot.width,
            height: dot.width,
            top: dot.top,
            right: dot.right,
            borderRadius: "50%",
            background: "#7EC553",
            boxShadow: "0 2px 6px rgba(66, 111, 41, .22)",
            animation: `crediarc-think-float 1.35s ease-in-out ${dot.delay} infinite`,
          }}
        />
      ))}
    </Box>
  </Box>
);

export default BrandThinkingLoader;
